(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9998],{

/***/ 96819:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/quotation",
      function () {
        return __webpack_require__(38869);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 5324:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94589);
/* harmony import */ var _types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39112);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  // background-color: ",
        ";\n  border-radius: 16px;\n  // box-shadow: ",
        ";\n  color: ",
        ";\n  display: block;\n  font-size: 16px;\n  height: ",
        ";\n  outline: 0;\n  padding: 0 16px;\n  width: 100%;\n  // border: 1px solid ",
        ";\n  border: none;\n  font-weight: 600;\n\n  &::placeholder {\n    /* color: ",
        "; */\n    color: #999;\n  }\n\n  &:disabled {\n    background-color: ",
        ";\n    box-shadow: none;\n    color: ",
        ";\n    cursor: not-allowed;\n  }\n\n  &:focus:not(:disabled) {\n    box-shadow: ",
        ";\n    box-shadow: none;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}


/**
 * Priority: Warning --> Success
 */ var getBoxShadow = function getBoxShadow(param) {
    var _isSuccess = param.isSuccess, isSuccess = _isSuccess === void 0 ? false : _isSuccess, _isWarning = param.isWarning, isWarning = _isWarning === void 0 ? false : _isWarning, theme = param.theme;
    if (isWarning) {
        return theme.shadows.warning;
    }
    if (isSuccess) {
        return theme.shadows.success;
    }
    return theme.shadows.inset;
};
var getHeight = function getHeight(param) {
    var _scale = param.scale, scale = _scale === void 0 ? _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.MD */ .Q.MD : _scale;
    switch(scale){
        case _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.SM */ .Q.SM:
            return "32px";
        case _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.LG */ .Q.LG:
            return "48px";
        case _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.MD */ .Q.MD:
        default:
            return "40px";
    }
};
var Input = styled_components__WEBPACK_IMPORTED_MODULE_2__/* ["default"].input.withConfig */ .ZP.input.withConfig({
    componentId: "sc-996b64d7-0"
}).withConfig({
    componentId: "sc-de4b360c-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.input;
}, getBoxShadow, function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, getHeight, function(param) {
    var theme = param.theme;
    return theme.colors.inputSecondary;
}, function(param) {
    var theme = param.theme;
    return theme.colors.textSubtle;
}, function(param) {
    var theme = param.theme;
    return theme.colors.backgroundDisabled;
}, function(param) {
    var theme = param.theme;
    return theme.colors.textDisabled;
}, function(param) {
    var theme = param.theme, isWarning = param.isWarning, isSuccess = param.isSuccess;
    if (isWarning) {
        return theme.shadows.warning;
    }
    if (isSuccess) {
        return theme.shadows.success;
    }
    return theme.shadows.focus;
});
Input.defaultProps = {
    scale: _types__WEBPACK_IMPORTED_MODULE_1__/* .scales.MD */ .Q.MD,
    isSuccess: false,
    isWarning: false
};
/* harmony default export */ __webpack_exports__["Z"] = (Input);


/***/ }),

/***/ 39112:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ scales; }
/* harmony export */ });
var scales = {
    SM: "sm",
    MD: "md",
    LG: "lg"
};


/***/ }),

/***/ 84091:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "i": function() { return /* binding */ SkeletonV2; },
  "Z": function() { return /* binding */ Skeleton_Skeleton; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion-minimal.mjs + 23 modules
var motion_minimal = __webpack_require__(45962);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/LazyMotion/index.mjs
var LazyMotion = __webpack_require__(18522);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/features-animation.mjs + 27 modules
var features_animation = __webpack_require__(55606);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/components/AnimatePresence/index.mjs + 3 modules
var AnimatePresence = __webpack_require__(21190);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(94589);
// EXTERNAL MODULE: ./node_modules/styled-system/dist/index.esm.js + 13 modules
var index_esm = __webpack_require__(57247);
;// CONCATENATED MODULE: ./packages/uikit/src/components/Skeleton/types.ts
var types_animation = {
    WAVES: "waves",
    PULSE: "pulse"
};
var types_variant = {
    RECT: "rect",
    CIRCLE: "circle"
};

// EXTERNAL MODULE: ./packages/uikit/src/util/animationToolkit.ts
var animationToolkit = __webpack_require__(98903);
;// CONCATENATED MODULE: ./packages/uikit/src/components/Skeleton/Skeleton.tsx




function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n   from {\n        left: -150px;\n    }\n    to   {\n        left: 100%;\n    }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  0% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.4;\n  }\n  100% {\n    opacity: 1;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  will-change: opacity;\n  opacity: 0;\n  &.appear {\n    animation: ",
        " 0.3s ease-in-out forwards;\n  }\n  &.disappear {\n    animation: ",
        " 0.3s ease-in-out forwards;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  ",
        "\n  ",
        "\n  overflow: hidden;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  min-height: 20px;\n  display: block;\n  background-color: ",
        ";\n  border-radius: ",
        ";\n  ",
        "\n  ",
        "\n  ",
        "\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  animation: ",
        " 2s infinite ease-out;\n  transform: translate3d(0, 0, 0);\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        '\n  overflow: hidden;\n  transform: translate3d(0, 0, 0);\n  &:before {\n    content: "";\n    position: absolute;\n    background-image: linear-gradient(90deg, transparent, rgba(243, 243, 243, 0.5), transparent);\n    top: 0;\n    left: -150px;\n    height: 100%;\n    width: 150px;\n    animation: ',
        " 2s cubic-bezier(0.4, 0, 0.2, 1) infinite;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}







var waves = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject());
var pulse = (0,styled_components_browser_esm/* keyframes */.F4)(_templateObject1());
var AnimationWrapper = (0,styled_components_browser_esm/* default */.ZP)(motion_minimal.m.div).withConfig({
    componentId: "sc-94de765-0"
}).withConfig({
    componentId: "sc-bfc8af08-0"
})(_templateObject2(), animationToolkit/* appearAnimation */.Oz, animationToolkit/* disappearAnimation */.a4);
var SkeletonWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-94de765-1"
}).withConfig({
    componentId: "sc-bfc8af08-1"
})(_templateObject3(), index_esm/* layout */.bK, index_esm/* space */.Dh);
var Root = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-94de765-2"
}).withConfig({
    componentId: "sc-bfc8af08-2"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.backgroundDisabled;
}, function(param) {
    var variant = param.variant, theme = param.theme;
    return variant === types_variant.CIRCLE ? theme.radii.circle : theme.radii.small;
}, index_esm/* layout */.bK, index_esm/* space */.Dh, index_esm/* borderRadius */.E0);
var Pulse = (0,styled_components_browser_esm/* default */.ZP)(Root).withConfig({
    componentId: "sc-94de765-3"
}).withConfig({
    componentId: "sc-bfc8af08-3"
})(_templateObject5(), pulse);
var Waves = (0,styled_components_browser_esm/* default */.ZP)(Root).withConfig({
    componentId: "sc-94de765-4"
}).withConfig({
    componentId: "sc-bfc8af08-4"
})(_templateObject6(), waves);
var Skeleton = function Skeleton(_param) {
    var _variant = _param.variant, variant = _variant === void 0 ? types_variant.RECT : _variant, _animation = _param.animation, animation = _animation === void 0 ? types_animation.PULSE : _animation, props = (0,_object_without_properties/* default */.Z)(_param, [
        "variant",
        "animation"
    ]);
    if (animation === types_animation.WAVES) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Waves, (0,_object_spread/* default */.Z)({
            variant: variant
        }, props));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Pulse, (0,_object_spread/* default */.Z)({
        variant: variant
    }, props));
};
var SkeletonV2 = function SkeletonV2(_param) {
    var _variant = _param.variant, variant = _variant === void 0 ? types_variant.RECT : _variant, _animation = _param.animation, animation = _animation === void 0 ? types_animation.PULSE : _animation, _isDataReady = _param.isDataReady, isDataReady = _isDataReady === void 0 ? false : _isDataReady, children = _param.children, wrapperProps = _param.wrapperProps, _skeletonTop = _param.skeletonTop, skeletonTop = _skeletonTop === void 0 ? "0" : _skeletonTop, _skeletonLeft = _param.skeletonLeft, skeletonLeft = _skeletonLeft === void 0 ? "0" : _skeletonLeft, width = _param.width, height = _param.height, mr = _param.mr, ml = _param.ml, props = (0,_object_without_properties/* default */.Z)(_param, [
        "variant",
        "animation",
        "isDataReady",
        "children",
        "wrapperProps",
        "skeletonTop",
        "skeletonLeft",
        "width",
        "height",
        "mr",
        "ml"
    ]);
    var animationRef = (0,react.useRef)(null);
    var skeletonRef = (0,react.useRef)(null);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: width,
        height: height,
        mr: mr,
        ml: ml
    }, wrapperProps), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(LazyMotion/* LazyMotion */.X, {
            features: features_animation/* domAnimation */.H,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(AnimatePresence/* AnimatePresence */.M, {
                children: [
                    isDataReady && /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimationWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        ref: animationRef,
                        onAnimationStart: function onAnimationStart() {
                            return (0,animationToolkit/* animationHandler */.BI)(animationRef.current);
                        }
                    }, animationToolkit/* animationMap */.Gc), {
                        variants: animationToolkit/* animationVariants */.ji,
                        transition: {
                            duration: 0.3
                        },
                        children: children
                    }), "content"),
                    !isDataReady && /*#__PURE__*/ (0,jsx_runtime.jsx)(AnimationWrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                        style: {
                            position: "absolute",
                            top: skeletonTop,
                            left: skeletonLeft
                        },
                        ref: skeletonRef,
                        onAnimationStart: function onAnimationStart() {
                            return (0,animationToolkit/* animationHandler */.BI)(skeletonRef.current);
                        }
                    }, animationToolkit/* animationMap */.Gc), {
                        variants: animationToolkit/* animationVariants */.ji,
                        transition: {
                            duration: 0.3
                        },
                        children: animation === types_animation.WAVES ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Waves, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            variant: variant
                        }, props), {
                            width: width,
                            height: height
                        })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Pulse, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                            variant: variant
                        }, props), {
                            width: width,
                            height: height
                        }))
                    }), "skeleton")
                ]
            })
        })
    }));
};
/* harmony default export */ var Skeleton_Skeleton = (Skeleton);


/***/ }),

/***/ 53629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ NextLinkFromReactRouter; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99534);
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94589);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);




function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var A = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-a01cb22d-0"
})(_templateObject());
/**
 * temporary solution for migrating React Router to Next.js Link
 */ var NextLinkFromReactRouter = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_2__.forwardRef)(function(_param, ref) /*#__PURE__*/ {
    var to = _param.to, replace = _param.replace, children = _param.children, prefetch = _param.prefetch, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "to",
        "replace",
        "children",
        "prefetch"
    ]);
    return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
        href: to,
        replace: replace,
        passHref: true,
        prefetch: prefetch,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(A, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
            ref: ref
        }, props), {
            children: children
        }))
    });
});


/***/ }),

/***/ 4003:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bq": function() { return /* binding */ ONE_DAY_UNIX; },
/* harmony export */   "Tb": function() { return /* binding */ ONE_HOUR_SECONDS; },
/* harmony export */   "si": function() { return /* binding */ ITEMS_PER_INFO_TABLE_PAGE; }
/* harmony export */ });
/* unused harmony exports MINIMUM_SEARCH_CHARACTERS, WEEKS_IN_YEAR, TOTAL_FEE, LP_HOLDERS_FEE, TREASURY_FEE, BUYBACK_FEE, PCS_V2_START, TOKEN_BLACKLIST */
var MINIMUM_SEARCH_CHARACTERS = 2;
var WEEKS_IN_YEAR = 52.1429;
var TOTAL_FEE = 0.003;
var LP_HOLDERS_FEE = 0.0017;
var TREASURY_FEE = 0.000225;
var BUYBACK_FEE = 0.000575;
var PCS_V2_START = 1619136000 // April 23, 2021, 12:00:00 AM
;
var ONE_DAY_UNIX = 86400 // 24h * 60m * 60s
;
var ONE_HOUR_SECONDS = 3600;
var ITEMS_PER_INFO_TABLE_PAGE = 10;
// These tokens are either incorrectly priced or have some other issues that spoil the query data
// None of them present any interest as they have almost 0 daily trade volume
var TOKEN_BLACKLIST = (/* unused pure expression or super */ null && ([
    // These ones are copied from v1 info
    "0x495c7f3a713870f68f8b418b355c085dfdc412c3",
    "0xc3761eb917cd790b30dad99f6cc5b4ff93c4f9ea",
    "0xe31debd7abff90b06bca21010dd860d8701fd901",
    "0xfc989fbb6b3024de5ca0144dc23c18a063942ac1",
    "0xe40fc6ff5f2895b44268fd2e1a421e07f567e007",
    "0xfd158609228b43aa380140b46fff3cdf9ad315de",
    "0xc00af6212fcf0e6fd3143e692ccd4191dc308bea",
    "0x205969b3ad459f7eba0dee07231a6357183d3fb6",
    "0x0bd67d358636fd7b0597724aa4f20beedbf3073a",
    "0xedf5d2a561e8a3cb5a846fbce24d2ccd88f50075",
    "0x702b0789a3d4dade1688a0c8b7d944e5ba80fc30",
    "0x041929a760d7049edaef0db246fa76ec975e90cc",
    "0xba098df8c6409669f5e6ec971ac02cd5982ac108",
    "0x1bbed115afe9e8d6e9255f18ef10d43ce6608d94",
    "0xe99512305bf42745fae78003428dcaf662afb35d",
    "0xbE609EAcbFca10F6E5504D39E3B113F808389056",
    "0x847daf9dfdc22d5c61c4a857ec8733ef5950e82e",
    "0xdbf8913dfe14536c0dae5dd06805afb2731f7e7b",
    // These ones are newly found
    "0xF1D50dB2C40b63D2c598e2A808d1871a40b1E653",
    "0x4269e4090ff9dfc99d8846eb0d42e67f01c3ac8b", 
]));


/***/ }),

/***/ 38869:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ quotation; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
// EXTERNAL MODULE: ./src/components/Layout/Page.tsx + 2 modules
var Page = __webpack_require__(89491);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(94589);
// EXTERNAL MODULE: ./src/components/NextLink.tsx
var NextLink = __webpack_require__(53629);
// EXTERNAL MODULE: ./packages/uikit/src/components/Input/Input.tsx
var Input = __webpack_require__(5324);
// EXTERNAL MODULE: ./packages/uikit/src/components/Skeleton/Skeleton.tsx + 1 modules
var Skeleton = __webpack_require__(84091);
// EXTERNAL MODULE: ./packages/uikit/src/components/Box/Flex.tsx
var Flex = __webpack_require__(4318);
// EXTERNAL MODULE: ./packages/uikit/src/components/Text/Text.tsx
var Text = __webpack_require__(97114);
// EXTERNAL MODULE: ./src/utils/formatInfoNumbers.ts
var formatInfoNumbers = __webpack_require__(56245);
// EXTERNAL MODULE: ./src/config/constants/info.ts
var info = __webpack_require__(4003);
// EXTERNAL MODULE: ./src/views/Info/components/CurrencyLogo/index.tsx + 1 modules
var CurrencyLogo = __webpack_require__(60764);
// EXTERNAL MODULE: ./packages/localization/src/index.tsx + 4 modules
var src = __webpack_require__(65208);
// EXTERNAL MODULE: ./src/views/Info/components/InfoTables/shared.tsx
var shared = __webpack_require__(58910);
;// CONCATENATED MODULE: ./src/views/Info/components/InfoTables/QuotationTable.tsx
/* eslint-disable */ 
function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-gap: 1em;\n  align-items: center;\n  grid-template-columns: 230px repeat(4, 2fr);\n  /* grid-template-columns: repeat(4, 2fr); */\n  background: ",
        ";\n\n  padding: ",
        ";\n  margin-top: ",
        ";\n  border-radius: ",
        ";\n  text-align: center;\n  /* padding: 0 24px; */\n  /* @media screen and (max-width: 900px) {\n    grid-template-columns: 200px 1.5fr repeat(3, 2fr);\n    & :nth-child(4) {\n      display: none;\n    }\n  } */\n  @media screen and (max-width: 500px) {\n    grid-template-columns: 20px 1.5fr repeat(1, 1fr);\n    & :nth-child(2),\n    & :nth-child(3) {\n      display: none;\n    }\n  }\n  @media screen and (max-width: 480px) {\n    grid-template-columns: 2.5fr repeat(1, 1fr);\n    > *:nth-child(1) {\n      display: none;\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-decoration: none;\n  :hover {\n    cursor: pointer;\n    opacity: 0.7;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 200px;\n  z-index: 9999;\n  border: 1px solid;\n  /* border-color: #e9e9e9; */\n  font-size: 14px;\n  color: #000;\n  padding-left: 36px;\n  border-radius: 5px;\n  height: 28px;\n  border-color: ",
        ";\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  right: 12px;\n  top: 45%;\n  transform: translateY(-50%);\n  z-index: 10;\n  cursor: pointer;\n  color: #000;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 10;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  background: ",
        ";\n  border-width: 1px;\n  border-style: solid;\n  font-size: 14px;\n  /* font-weight: ",
        "; */\n  padding: 5px 10px;\n  border-radius: 6px;\n  border-color: ",
        ";\n  margin-right: 10px;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}










/**
 *  Columns on different layouts
 *  5 = | # | Pool | TVL | Volume 24H | Volume 7D |
 *  4 = | # | Pool |     | Volume 24H | Volume 7D |
 *  3 = | # | Pool |     | Volume 24H |           |
 *  2 = |   | Pool |     | Volume 24H |           |
 */ var ResponsiveGrid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-27be34d3-0"
})(_templateObject(), function(param) {
    var tableHead = param.tableHead;
    return tableHead ? "#FaFaFa" : "#fff";
}, function(param) {
    var tableHead = param.tableHead;
    return tableHead ? "8px 24px" : "0 24px";
}, function(param) {
    var tableHead = param.tableHead;
    return tableHead ? "10px" : "0px";
}, function(param) {
    var tableHead = param.tableHead;
    return tableHead ? "8px" : "0px";
});
var LinkWrapper = (0,styled_components_browser_esm/* default */.ZP)(NextLink/* NextLinkFromReactRouter */.a).withConfig({
    componentId: "sc-27be34d3-1"
})(_templateObject1());
var StyledInput = (0,styled_components_browser_esm/* default */.ZP)(Input/* default */.Z).withConfig({
    componentId: "sc-27be34d3-2"
})(_templateObject2(), function(param) {
    var inputBlur = param.inputBlur;
    return inputBlur ? "#000" : "#e9e9e9";
});
var SearchDeleteIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-27be34d3-3"
})(_templateObject3());
var SearchLogo = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-27be34d3-4"
})(_templateObject4());
var FlexRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-27be34d3-5"
})(_templateObject5(), function(param) {
    var active = param.active;
    return active ? "#FAD436" : "#fff";
}, function(param) {
    var active = param.active;
    return active ? 600 : 400;
}, function(param) {
    var active = param.active;
    return active ? "#14162A" : "#fff";
});
var SORT_FIELD = {
    liquidityUSD: "liquidityUSD",
    volumeUSD: "volumeUSD",
    // volumeUSDWeek: 'volumeUSDWeek',
    // lpFees24h: 'lpFees24h',
    // lpApr7d: 'lpApr7d',
    price: "price",
    priceChange: "priceChange"
};
var LoadingRow = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(ResponsiveGrid, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {})
        ]
    });
};
var TableLoader = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingRow, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingRow, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingRow, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingRow, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(LoadingRow, {})
        ]
    });
};
var DataRow = function(param) {
    var poolData = param.poolData, index = param.index;
    var ref, ref1;
    var symbolChange = {
        token0: poolData === null || poolData === void 0 ? void 0 : poolData.token0,
        token1: poolData === null || poolData === void 0 ? void 0 : poolData.token1
    };
    // const symbolArr = ['DAI', 'USDT', 'USDC']
    // if (poolData?.token0?.symbol === 'WEOS' && !symbolArr.find((item) => item === poolData?.token1?.symbol)) {
    //   symbolChange = {
    //     token0: poolData?.token1,
    //     token1: poolData?.token0,
    //   }
    // }
    if ((poolData === null || poolData === void 0 ? void 0 : poolData.direction) === 1) {
        symbolChange = {
            token0: poolData === null || poolData === void 0 ? void 0 : poolData.token1,
            token1: poolData === null || poolData === void 0 ? void 0 : poolData.token0
        };
    }
    var priceChange = poolData.priceChange > 0 ? "+".concat(poolData.priceChange.toFixed(2)) : poolData.priceChange === 0 ? "0.00" : "".concat(poolData.priceChange.toFixed(2));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkWrapper, {
        to: "/info/pools/".concat(poolData.address),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ResponsiveGrid, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo/* DoubleCurrencyLogo */.g, {
                            token0: symbolChange.token0,
                            token1: symbolChange.token1,
                            size: 30
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            style: {
                                marginLeft: "30px"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                                    style: {
                                        fontWeight: 500
                                    },
                                    children: symbolChange === null || symbolChange === void 0 ? void 0 : (ref = symbolChange.token0) === null || ref === void 0 ? void 0 : ref.symbol
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                    style: {
                                        fontWeight: 500
                                    },
                                    color: "#92929B",
                                    children: [
                                        "/",
                                        symbolChange === null || symbolChange === void 0 ? void 0 : (ref1 = symbolChange.token1) === null || ref1 === void 0 ? void 0 : ref1.symbol
                                    ]
                                })
                            ]
                        }),
                        poolData.newPair && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                            style: {
                                marginLeft: "10px"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                src: "/images/ad/new.png",
                                alt: "",
                                width: "36"
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    alignItems: "flex-end",
                    justifyContent: "flex-end",
                    flexDirection: "column",
                    style: {
                        flexFlow: !(poolData === null || poolData === void 0 ? void 0 : poolData.priceUsd) && "wrap"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            children: (0,formatInfoNumbers/* formatNumber */.uf)((0,formatInfoNumbers/* formatPrice */.T4)(poolData.price), poolData.price)
                        }),
                        (poolData === null || poolData === void 0 ? void 0 : poolData.priceUsd) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                            fontSize: "12px",
                            color: "#92929B",
                            children: [
                                "$",
                                (0,formatInfoNumbers/* formatNumber */.uf)((0,formatInfoNumbers/* formatUsd */.gC)(poolData.priceUsd), poolData.priceUsd)
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: "12px",
                            color: "#92929B",
                            children: "\xa0"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                    color: poolData.priceChange > 0 ? "green" : poolData.priceChange < 0 ? "red" : "",
                    textAlign: "right",
                    children: [
                        priceChange,
                        "%"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                    textAlign: "right",
                    children: [
                        "$",
                        (0,formatInfoNumbers/* formatAmount */.dN)(poolData.volumeUSD)
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                    textAlign: "right",
                    children: [
                        "$",
                        (0,formatInfoNumbers/* formatAmount */.dN)(poolData.liquidityUSD)
                    ]
                })
            ]
        })
    });
};
var QuotationTable = function(param) {
    var poolDatas = param.poolDatas, loading = param.loading, title = param.title, searchValue = param.searchValue, setSearchValue = param.setSearchValue, tableType = param.tableType, setTableType = param.setTableType;
    // for sorting
    var ref = (0,react.useState)(SORT_FIELD.liquidityUSD), sortField = ref[0], setSortField = ref[1];
    var ref1 = (0,react.useState)(true), sortDirection = ref1[0], setSortDirection = ref1[1];
    var t = (0,src/* useTranslation */.$G)().t;
    // pagination
    var ref2 = (0,react.useState)(1), page = ref2[0], setPage = ref2[1];
    var ref3 = (0,react.useState)(1), maxPage = ref3[0], setMaxPage = ref3[1];
    var ref4 = (0,react.useState)(false), inputBlur = ref4[0], setInputBlur = ref4[1];
    // useEffect(() => {
    //   let extraPages = 1
    //   if (poolDatas?.length % ITEMS_PER_INFO_TABLE_PAGE === 0) {
    //     extraPages = 0
    //   }
    //   setMaxPage(Math.floor(poolDatas?.length / ITEMS_PER_INFO_TABLE_PAGE) + extraPages)
    // }, [poolDatas])
    var sortedPools = (0,react.useMemo)(function() {
        return poolDatas ? poolDatas.sort(function(a, b) {
            if (a && b) {
                return a[sortField] > b[sortField] ? (sortDirection ? -1 : 1) * 1 : (sortDirection ? -1 : 1) * -1;
            }
            return -1;
        }) : [];
    }, [
        page,
        poolDatas,
        sortDirection,
        sortField
    ]);
    var handleSort = (0,react.useCallback)(function(newField) {
        setSortField(newField);
        setSortDirection(sortField !== newField ? true : !sortDirection);
    }, [
        sortDirection,
        sortField
    ]);
    var arrow = (0,react.useCallback)(function(field) {
        var directionArrow = !sortDirection ? "↑" : "↓";
        return sortField === field ? directionArrow : "";
    }, [
        sortDirection,
        sortField
    ]);
    var handleSearchValue = function(e) {
        setSearchValue(e.target.value);
    };
    var handleTab = function(id) {
        setTableType(id);
    };
    var tabArr = [
        {
            id: 0,
            label: t("noah92")
        },
        {
            id: 1,
            label: "EOS"
        },
        {
            id: 2,
            label: t("noah196")
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(shared/* TableWrapper */.y6, {
        style: {
            padding: loading ? "24px" : "24px",
            minHeight: "80vh"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    color: "#000",
                    fontSize: "20px",
                    bold: true,
                    children: title
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justifyContent: "space-between",
                alignItems: "center",
                children: [
                    !searchValue ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        children: tabArr.map(function(v) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(FlexRow, {
                                active: v.id === tableType,
                                onClick: function() {
                                    return handleTab(v.id);
                                },
                                children: v.label
                            }, v.id);
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: "14px",
                            color: "#92929B",
                            children: t("%num% results found", {
                                num: poolDatas === null || poolDatas === void 0 ? void 0 : poolDatas.length
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            position: "relative"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchLogo, {
                                src: "/images/small-img/icon3.png",
                                width: 16,
                                alt: ""
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                style: {
                                    position: "relative"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledInput, {
                                        type: "text",
                                        onFocus: function() {
                                            return setInputBlur(true);
                                        },
                                        onBlur: function() {
                                            return setInputBlur(false);
                                        },
                                        inputBlur: inputBlur,
                                        value: searchValue,
                                        onChange: handleSearchValue,
                                        placeholder: t("noah100")
                                    }),
                                    searchValue && /*#__PURE__*/ (0,jsx_runtime.jsx)(SearchDeleteIcon, {
                                        onClick: function() {
                                            return setSearchValue("");
                                        },
                                        children: "\xd7"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(ResponsiveGrid, {
                tableHead: true,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        color: "#000",
                        fontSize: "12px",
                        bold: true,
                        textAlign: "left",
                        children: t("noah37")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(shared/* ClickableColumnHeader */._J, {
                        color: "#000",
                        fontSize: "12px",
                        bold: true,
                        onClick: function() {
                            return handleSort(SORT_FIELD.price);
                        },
                        textAlign: "right",
                        children: [
                            t("noah81"),
                            arrow(SORT_FIELD.price)
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(shared/* ClickableColumnHeader */._J, {
                        color: "#000",
                        fontSize: "12px",
                        bold: true,
                        onClick: function() {
                            return handleSort(SORT_FIELD.priceChange);
                        },
                        textAlign: "right",
                        children: [
                            t("noah91"),
                            arrow(SORT_FIELD.priceChange)
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(shared/* ClickableColumnHeader */._J, {
                        color: "#000",
                        fontSize: "12px",
                        bold: true,
                        onClick: function() {
                            return handleSort(SORT_FIELD.volumeUSD);
                        },
                        textAlign: "right",
                        children: [
                            t("noah194"),
                            " ",
                            arrow(SORT_FIELD.volumeUSD)
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(shared/* ClickableColumnHeader */._J, {
                        color: "#000",
                        fontSize: "12px",
                        bold: true,
                        onClick: function() {
                            return handleSort(SORT_FIELD.liquidityUSD);
                        },
                        textAlign: "right",
                        children: [
                            t("noah37"),
                            " ",
                            arrow(SORT_FIELD.liquidityUSD)
                        ]
                    })
                ]
            }),
            loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(TableLoader, {}) : sortedPools.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                children: sortedPools.map(function(poolData, i) {
                    if (poolData) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(DataRow, {
                                    index: (page - 1) * info/* ITEMS_PER_INFO_TABLE_PAGE */.si + i,
                                    poolData: poolData
                                }),
                                i < sortedPools.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* Break */.SS, {})
                            ]
                        }, poolData.address);
                    }
                    return null;
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "500px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: "/images/small-img/noData.png",
                        width: 100,
                        alt: ""
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        textAlign: "center",
                        maxWidth: "400px",
                        fontSize: "16px",
                        mt: "16px",
                        color: "#85868A",
                        children: t("noah116")
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var InfoTables_QuotationTable = (QuotationTable);

// EXTERNAL MODULE: ./src/service/service.ts + 1 modules
var service = __webpack_require__(36141);
// EXTERNAL MODULE: ./src/views/Info/utils/infoDataHelpers.ts
var infoDataHelpers = __webpack_require__(40393);
// EXTERNAL MODULE: ./src/hooks/useDebounce.ts
var useDebounce = __webpack_require__(55999);
// EXTERNAL MODULE: ./packages/uikit/src/contexts/MatchBreakpoints/useMatchBreakpoints.ts
var useMatchBreakpoints = __webpack_require__(25349);
// EXTERNAL MODULE: ./src/service/chainUtils.ts
var chainUtils = __webpack_require__(99635);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/views/Quotation/components/QuotationMobile.tsx

function QuotationMobile_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: #fff;\n  border-radius: 20px;\n  min-height: 200px;\n  padding: 14px 0;\n"
    ]);
    QuotationMobile_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function QuotationMobile_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 142px;\n  height: 33px;\n  z-index: 9999;\n  padding-left: 36px;\n  border: 1px solid;\n  border-color: #e9e9e9 !important;\n  font-size: 12px;\n  color: #000;\n  border-radius: 5px;\n  height: 28px;\n  border-color: ",
        ";\n"
    ]);
    QuotationMobile_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function QuotationMobile_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  right: 12px;\n  top: 45%;\n  transform: translateY(-50%);\n  z-index: 10;\n  cursor: pointer;\n  color: #000;\n"
    ]);
    QuotationMobile_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function QuotationMobile_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: grid;\n  grid-gap: 0;\n  align-items: center;\n  /* grid-template-columns: 33px 3fr repeat(2, 2fr); */\n  grid-template-columns: 2fr repeat(2, 2fr);\n  background: ",
        ";\n\n  margin-top: ",
        ";\n  border-radius: ",
        ";\n  text-align: center;\n"
    ]);
    QuotationMobile_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function QuotationMobile_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  text-decoration: none;\n  :hover {\n    cursor: pointer;\n    opacity: 0.7;\n  }\n"
    ]);
    QuotationMobile_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function QuotationMobile_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 86%;\n  height: 34px;\n  line-height: 34px;\n  font-weight: bold;\n  text-align: center;\n  font-size: 13px;\n  background-color: ",
        ";\n  border-radius: 10px;\n  color: #fff;\n"
    ]);
    QuotationMobile_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: absolute;\n  left: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 10;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  background: ",
        ";\n  border-width: 1px;\n  border-style: solid;\n  font-size: 14px;\n  padding: 3px 10px;\n  border-radius: 6px;\n  border-color: ",
        ";\n  margin-right: 10px;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}








var QuotationMobileWrap = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-acf5b191-0"
})(QuotationMobile_templateObject());
var QuotationMobile_StyledInput = (0,styled_components_browser_esm/* default */.ZP)(Input/* default */.Z).withConfig({
    componentId: "sc-acf5b191-1"
})(QuotationMobile_templateObject1(), function(param) {
    var inputBlur = param.inputBlur;
    return inputBlur ? "#000" : "#e9e9e9";
});
var QuotationMobile_SearchDeleteIcon = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-acf5b191-2"
})(QuotationMobile_templateObject2());
var QuotationMobile_ResponsiveGrid = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-acf5b191-3"
})(QuotationMobile_templateObject3(), function(param) {
    var tableHead = param.tableHead;
    return tableHead ? "#F2F2F2" : "#fff";
}, function(param) {
    var tableHead = param.tableHead;
    return tableHead ? "10px" : "3px";
}, function(param) {
    var tableHead = param.tableHead;
    return tableHead ? "8px" : "0px";
});
var QuotationMobile_LinkWrapper = (0,styled_components_browser_esm/* default */.ZP)(NextLink/* NextLinkFromReactRouter */.a).withConfig({
    componentId: "sc-acf5b191-4"
})(QuotationMobile_templateObject4());
var ChangeBtn = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-acf5b191-5"
})(QuotationMobile_templateObject5(), function(param) {
    var priceChange = param.priceChange;
    return priceChange > 0 ? "#17BA78" : priceChange === 0 ? "#999" : "red";
});
var QuotationMobile_SearchLogo = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
    componentId: "sc-acf5b191-6"
})(_templateObject6());
var QuotationMobile_FlexRow = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-acf5b191-7"
})(_templateObject7(), function(param) {
    var active = param.active;
    return active ? "#FAD436" : "#fff";
}, function(param) {
    var active = param.active;
    return active ? "#14162A" : "#fff";
});
var QuotationMobile_DataRow = function(param) {
    var poolData = param.poolData, index = param.index;
    var ref, ref1;
    var t = (0,src/* useTranslation */.$G)().t;
    var priceChange = poolData.priceChange > 0 ? "+".concat(poolData.priceChange.toFixed(2)) : poolData.priceChange === 0 ? "0.00" : "".concat(poolData.priceChange.toFixed(2));
    var symbolChange = {
        token0: poolData === null || poolData === void 0 ? void 0 : poolData.token0,
        token1: poolData === null || poolData === void 0 ? void 0 : poolData.token1
    };
    if ((poolData === null || poolData === void 0 ? void 0 : poolData.direction) === 1) {
        symbolChange = {
            token0: poolData === null || poolData === void 0 ? void 0 : poolData.token1,
            token1: poolData === null || poolData === void 0 ? void 0 : poolData.token0
        };
    }
    // const symbolArr = ['DAI', 'USDT', 'USDC']
    // if (poolData?.token0?.symbol === 'WEOS' && !symbolArr.find((item) => item === poolData?.token1?.symbol)) {
    //   symbolChange = {
    //     token0: poolData?.token1,
    //     token1: poolData?.token0,
    //   }
    // }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(QuotationMobile_LinkWrapper, {
        to: "/info/pools/".concat(poolData.address),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(QuotationMobile_ResponsiveGrid, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    justifyContent: "center",
                    alignItems: "center",
                    flexDirection: "column",
                    style: {
                        height: "25px"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                            alignItems: "center",
                            style: {
                                placeSelf: "flex-start"
                            },
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                            mb: "4px",
                                            fontSize: "14px",
                                            fontWeight: "900",
                                            children: [
                                                symbolChange === null || symbolChange === void 0 ? void 0 : (ref = symbolChange.token0) === null || ref === void 0 ? void 0 : ref.symbol,
                                                " "
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                            color: "#92929B",
                                            fontSize: "14px",
                                            fontWeight: "900",
                                            children: [
                                                "/",
                                                symbolChange === null || symbolChange === void 0 ? void 0 : (ref1 = symbolChange.token1) === null || ref1 === void 0 ? void 0 : ref1.symbol
                                            ]
                                        })
                                    ]
                                }),
                                poolData.newPair && /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                                    style: {
                                        marginLeft: "4px",
                                        position: "relative",
                                        top: "-2px"
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "/images/ad/new.png",
                                        alt: "",
                                        width: "24",
                                        style: {
                                            objectFit: "contain"
                                        }
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                            style: {
                                placeSelf: "flex-start"
                            },
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                                fontSize: "12px",
                                color: "#92929B",
                                children: [
                                    t("noah194"),
                                    " $",
                                    (0,formatInfoNumbers/* formatAmount */.dN)(poolData.volumeUSD)
                                ]
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                    alignItems: "center",
                    flexDirection: "column",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            mb: "4px",
                            fontSize: "14px",
                            fontWeight: "900",
                            children: (0,formatInfoNumbers/* formatNumber */.uf)((0,formatInfoNumbers/* formatPrice */.T4)(poolData.price), poolData.price)
                        }),
                        (poolData === null || poolData === void 0 ? void 0 : poolData.priceUsd) ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                            fontSize: "12px",
                            color: "#92929B",
                            children: [
                                "$",
                                (0,formatInfoNumbers/* formatNumber */.uf)((0,formatInfoNumbers/* formatUsd */.gC)(poolData.priceUsd), poolData.priceUsd)
                            ]
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            fontSize: "12px",
                            color: "#92929B",
                            children: "\xa0"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    alignSelf: "flex-start",
                    flexDirection: "row-reverse",
                    pt: "4px",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ChangeBtn, {
                        priceChange: poolData.priceChange,
                        children: [
                            priceChange,
                            "%"
                        ]
                    })
                })
            ]
        })
    });
};
var QuotationMobile_LoadingRow = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(QuotationMobile_ResponsiveGrid, {
        style: {
            padding: "0 20px"
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {})
        ]
    });
};
var QuotationMobile_TableLoader = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuotationMobile_LoadingRow, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuotationMobile_LoadingRow, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuotationMobile_LoadingRow, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuotationMobile_LoadingRow, {})
        ]
    });
};
var QuotationMobile = function(param) {
    var poolDatas = param.poolDatas, loading = param.loading, title = param.title, searchValue = param.searchValue, setSearchValue = param.setSearchValue, tableType = param.tableType, setTableType = param.setTableType;
    var ref = (0,react.useState)(false), inputBlur = ref[0], setInputBlur = ref[1];
    var t = (0,src/* useTranslation */.$G)().t;
    var handleSearchValue = function(e) {
        setSearchValue(e.target.value);
    };
    var handleTab = function(id) {
        setTableType(id);
    };
    var poolDatass = poolDatas === null || poolDatas === void 0 ? void 0 : poolDatas.sort(function(a, b) {
        return (b === null || b === void 0 ? void 0 : b.usdBalance2) - (a === null || a === void 0 ? void 0 : a.usdBalance2);
    });
    var tabArr = [
        {
            id: 0,
            label: t("noah92")
        },
        {
            id: 1,
            label: "EOS"
        },
        {
            id: 2,
            label: t("noah196")
        }, 
    ];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(QuotationMobileWrap, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justifyContent: "space-between",
                style: {
                    marginBottom: "14px",
                    padding: "0 20px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            color: "#000",
                            fontSize: "20px",
                            bold: true,
                            style: {
                                lineHeight: "30px"
                            },
                            children: title
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        style: {
                            position: "relative"
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuotationMobile_SearchLogo, {
                                src: "/images/small-img/icon3.png",
                                width: 16,
                                alt: ""
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                style: {
                                    position: "relative"
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(QuotationMobile_StyledInput, {
                                        type: "text",
                                        onFocus: function() {
                                            return setInputBlur(true);
                                        },
                                        onBlur: function() {
                                            return setInputBlur(false);
                                        },
                                        inputBlur: inputBlur,
                                        value: searchValue,
                                        onChange: handleSearchValue,
                                        placeholder: t("noah100")
                                    }),
                                    searchValue && /*#__PURE__*/ (0,jsx_runtime.jsx)(QuotationMobile_SearchDeleteIcon, {
                                        onClick: function() {
                                            return setSearchValue("");
                                        },
                                        children: "\xd7"
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                justifyContent: "space-between",
                alignItems: "center",
                style: {
                    marginBottom: "18px",
                    padding: "0 20px"
                },
                children: !searchValue ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    children: tabArr.map(function(v) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(QuotationMobile_FlexRow, {
                            active: v.id === tableType,
                            onClick: function() {
                                return handleTab(v.id);
                            },
                            children: v.label
                        }, v.id);
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "14px",
                        color: "#92929B",
                        children: t("%num% results found", {
                            num: poolDatas === null || poolDatas === void 0 ? void 0 : poolDatas.length
                        })
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                justifyContent: "space-between",
                style: {
                    marginBottom: "18px",
                    padding: "0 20px"
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "12px",
                        color: "#92929B",
                        children: t("noah37")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "12px",
                        color: "#92929B",
                        children: t("noah81")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        fontSize: "12px",
                        color: "#92929B",
                        children: t("noah91")
                    })
                ]
            }),
            loading ? /*#__PURE__*/ (0,jsx_runtime.jsx)(QuotationMobile_TableLoader, {}) : (poolDatass === null || poolDatass === void 0 ? void 0 : poolDatass.length) ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    height: "70vh",
                    overflow: "auto",
                    padding: "0 10px 0 20px"
                },
                children: poolDatass.map(function(poolData, i) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(react.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(QuotationMobile_DataRow, {
                                index: i,
                                poolData: poolData
                            }),
                            i !== (poolDatass === null || poolDatass === void 0 ? void 0 : poolDatass.length) - 1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(shared/* Break */.SS, {
                                style: {
                                    margin: "24px 0"
                                }
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                style: {
                                    marginBottom: "10px"
                                }
                            })
                        ]
                    }, poolData.address);
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                style: {
                    height: "200px",
                    lineHeight: "200px"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                    textAlign: "center",
                    bold: true,
                    maxWidth: "400px",
                    fontSize: "16px",
                    mb: "16px",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/images/small-img/noData.png",
                            width: 80,
                            alt: ""
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                            textAlign: "center",
                            maxWidth: "400px",
                            fontSize: "16px",
                            mt: "16px",
                            color: "#85868A",
                            children: t("noah116")
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var components_QuotationMobile = (QuotationMobile);

;// CONCATENATED MODULE: ./src/views/Quotation/index.tsx
/* eslint-disable */ 













function Quotation() {
    var ref = (0,react.useState)(""), searchValue = ref[0], setSearchValue = ref[1];
    var ref1 = (0,react.useState)(0), tableType = ref1[0], setTableType = ref1[1];
    var ref2 = (0,react.useState)(0), changeTableType = ref2[0], setChangeTableType = ref2[1];
    var debouncedQuery = (0,useDebounce/* default */.Z)(searchValue, 200);
    var ref3 = (0,react.useState)([]), fetchState = ref3[0], setFetchState = ref3[1];
    var ref4 = (0,react.useState)([]), defaultFetchState = ref4[0], setDefaultFetchState = ref4[1];
    var ref5 = (0,react.useState)(false), loading = ref5[0], setLoading = ref5[1];
    var t = (0,src/* useTranslation */.$G)().t;
    var isDesktop = (0,useMatchBreakpoints/* default */.Z)().isDesktop;
    var isMobile = isDesktop === false;
    // const { chainId } = useActiveWeb3React()
    var router = (0,next_router.useRouter)();
    // const parsedQueryChainId = Number(router.query.chainId)
    // const chainId = parsedQueryChainId || Number(localStorage.getItem('chainId'))
    (0,react.useEffect)(function() {
        var ref = (0,chainUtils/* default */.Z)(), baseURL = ref.baseURL, chainid = ref.chainid;
        setLoading(true);
        // console.log(tableType, 'tableType')
        // console.log(debouncedQuery, 'debouncedQuery')
        // if (debouncedQuery) {
        //   setTableType(0)
        // }
        // if (tableType) {
        //   setChangeTableType(tableType)
        // }
        var fetch = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function() {
                var params, ref, code, data, dataFormat;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            params = {
                                limit: 100,
                                type: 2,
                                orderColumn: "usd_balance",
                                isAsc: true,
                                symbol: debouncedQuery,
                                quoteCoin: debouncedQuery ? 0 : tableType
                            };
                            return [
                                4,
                                (0,service/* getMarket */.YK)(params, {
                                    baseURL: baseURL,
                                    chainid: chainid
                                })
                            ];
                        case 1:
                            ref = _state.sent(), code = ref.code, data = ref.data;
                            if (!code) {
                                dataFormat = data === null || data === void 0 ? void 0 : data.map(function(current) {
                                    var yesterdayPrice = (0,infoDataHelpers/* getPercentChange */.Y)(current === null || current === void 0 ? void 0 : current.price, current === null || current === void 0 ? void 0 : current.yesterday_price);
                                    var liquidityUSD = current ? current.usd_balance2 : 0;
                                    var liquidityUSDChange = (0,infoDataHelpers/* getPercentChange */.Y)((current === null || current === void 0 ? void 0 : current.usd_balance2) || 0, (current === null || current === void 0 ? void 0 : current.usd_balance2) || 0);
                                    var liquidityToken0 = current ? current.count0 : 0;
                                    var liquidityToken1 = current ? current.count1 : 0;
                                    return {
                                        reserve0: current.contract0,
                                        reserve1: current.contract1,
                                        address: current.pair_id.toString(),
                                        reserveUSD: liquidityUSD.toString(),
                                        token0: {
                                            address: current.contract0,
                                            name: current.name0,
                                            symbol: current.symbol0
                                        },
                                        token1: {
                                            address: current.contract1,
                                            name: current.name1,
                                            symbol: current.symbol1
                                        },
                                        token0Price: (current.count0 / current.count1).toString() || 0,
                                        token1Price: (current.count1 / current.count0).toString() || 0,
                                        volumeUSD: current.volume_usd_24h,
                                        volumeUSDChange: 0,
                                        totalFees24h: current.fee_usd_24h,
                                        // totalFees7d,
                                        lpFees24h: 0,
                                        // lpFees7d,
                                        lpApr7d: 0,
                                        liquidityUSD: liquidityUSD,
                                        liquidityUSDChange: liquidityUSDChange,
                                        liquidityToken0: liquidityToken0,
                                        liquidityToken1: liquidityToken1,
                                        price: current.price,
                                        priceUsd: current.priceUsd,
                                        priceChange: yesterdayPrice,
                                        swapCount: current.swap_count_24h,
                                        usdBalance2: current.usd_balance2,
                                        direction: current.price_direction,
                                        recommend: current.recommend,
                                        newPair: current.newPair
                                    };
                                });
                                setDefaultFetchState(dataFormat);
                                setTimeout(function() {
                                    setLoading(false);
                                }, 100);
                            } else {
                                setLoading(false);
                                setDefaultFetchState([]);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetch() {
                return _ref.apply(this, arguments);
            };
        }();
        var timer = setInterval(function() {
            fetch();
        }, 10000);
        fetch();
        return function() {
            return clearInterval(timer);
        };
    }, [
        tableType,
        debouncedQuery
    ]);
    // useEffect(() => {
    //   let dataFormat = defaultFetchState || []
    //   if (!debouncedQuery) {
    //     dataFormat = defaultFetchState
    //   } else {
    //     dataFormat = dataFormat.filter((v) => {
    //       return (
    //         v?.token0?.symbol.toUpperCase().indexOf(debouncedQuery.toUpperCase()) > -1 ||
    //         v?.token1?.symbol.toUpperCase().indexOf(debouncedQuery.toUpperCase()) > -1
    //       )
    //     })
    //   }
    //   setFetchState(dataFormat)
    // }, [debouncedQuery, defaultFetchState])
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Page/* default */.Z, {
        children: !isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(InfoTables_QuotationTable, {
            poolDatas: defaultFetchState,
            loading: loading,
            title: t("noah62"),
            searchValue: searchValue,
            setSearchValue: setSearchValue,
            tableType: tableType,
            setTableType: setTableType
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(components_QuotationMobile, {
            poolDatas: defaultFetchState,
            loading: loading,
            title: t("noah62"),
            searchValue: searchValue,
            setSearchValue: setSearchValue,
            tableType: tableType,
            setTableType: setTableType
        })
    });
}

;// CONCATENATED MODULE: ./src/pages/quotation/index.tsx


var QuotationPage = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Quotation, {});
};
QuotationPage.Layout = QuotationPage;
// QuotationPage.mp = false
/* harmony default export */ var quotation = (QuotationPage);


/***/ }),

/***/ 56245:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LH": function() { return /* binding */ formatTokenAmount; },
/* harmony export */   "T4": function() { return /* binding */ formatPrice; },
/* harmony export */   "dN": function() { return /* binding */ formatAmount; },
/* harmony export */   "gC": function() { return /* binding */ formatUsd; },
/* harmony export */   "uf": function() { return /* binding */ formatNumber; },
/* harmony export */   "wv": function() { return /* binding */ formatNumber2; }
/* harmony export */ });
/* unused harmony exports getFirstThreeNonZeroDecimals, getRes, getFullNum */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(828);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92077);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(numeral__WEBPACK_IMPORTED_MODULE_0__);


// Returns first 2 digits after first non-zero decimal
// i.e. 0.001286 -> 0.0012, 0.9845 -> 0.98, 0.0102 -> 0.010, etc
// Intended to be used for tokens whose value is less than $1
// https://stackoverflow.com/a/23887837
var getFirstThreeNonZeroDecimals = function(value) {
    return value === null || value === void 0 ? void 0 : value.toFixed(9).match(/^-?\d*\.?0*\d{0,2}/)[0];
};
/**
 * This function is used to format token prices, liquidity, amount of tokens in TX, and in general any numbers on info section
 * @param amount - amount to be formatted
 * @param notation - whether to show 1M or 1,000,000
 * @param displayThreshold - threshold below which it will return simply <displayThreshold instead of actual value, e.g. if 0.001 -> returns <0.001 for 0.0005
 * @param tokenPrecision - set to true when you want precision to be 3 decimals for values < 1 and 2 decimals for values > 1
 * @param isInteger - if true the values will contain decimal part only if the amount is > 1000
 * @returns formatted string ready to be displayed
 */ var formatAmount = function(amount, options) {
    var ref = options || {
        notation: "compact"
    }, _notation = ref.notation, notation = _notation === void 0 ? "compact" : _notation, displayThreshold = ref.displayThreshold, tokenPrecision = ref.tokenPrecision, isInteger = ref.isInteger;
    if (amount === 0) {
        if (isInteger) {
            return "0";
        }
        return "0.00";
    }
    if (!amount) return "-";
    if (displayThreshold && amount < displayThreshold) {
        return "<".concat(displayThreshold);
    }
    if (amount < 1 && !tokenPrecision) {
        return getFirstThreeNonZeroDecimals(amount);
    }
    var precision = 2;
    if (tokenPrecision) {
        precision = amount < 1 ? 3 : 2;
    }
    var format = "0.".concat("0".repeat(precision), "a");
    if (notation === "standard") {
        format = "0,0.".concat("0".repeat(precision));
    }
    if (isInteger && amount < 1000) {
        format = "0";
    }
    var amountWithPrecision = parseFloat(parseFloat(amount.toString()).toFixed(precision));
    // toUpperCase is needed cause numeral doesn't have support for capital K M B out of the box
    return numeral__WEBPACK_IMPORTED_MODULE_0___default()(amountWithPrecision).format(format).toUpperCase();
};
var formatUsd = function() {
    var price = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    if (price < 0.01) {
        return "< 0.01";
    }
    if (price >= 10000000000) {
        var ref;
        return "".concat((ref = Number(price / 1000000000)) === null || ref === void 0 ? void 0 : ref.toFixed(4), "B");
    }
    if (price >= 10000000) {
        var ref1;
        return "".concat((ref1 = Number(price / 1000000)) === null || ref1 === void 0 ? void 0 : ref1.toFixed(4), "M");
    }
    if (price >= 100000) {
        var ref2;
        return "".concat((ref2 = Number(price / 1000)) === null || ref2 === void 0 ? void 0 : ref2.toFixed(4), "K");
    }
    return Number(price).toFixed(2);
};
var getZeroNums = function(priceData) {
    var price = priceData.toString().split(".")[1] || "0.00";
    var indexOfs = price.indexOf("0");
    var returnValue = "";
    var nums = 0;
    var forConti = true;
    for(var i = 0; i < price.length; i++){
        var iNumber = Number(price[i]);
        var iNumber1 = Number(price[i + 1]);
        if (indexOfs === 0 && forConti) {
            if (iNumber === 0 && iNumber1 === 0) {
                nums++;
            } else {
                forConti = false;
            }
        }
    }
    if (nums > 3 && indexOfs === 0) {
        returnValue = "0.".concat(price.slice(0, indexOfs + 1), "{").concat(nums + 1, "}").concat(price.slice(nums + 1, nums + 4));
    } else if ((nums === 2 || nums === 3) && indexOfs === 0) {
        returnValue = Number(priceData).toFixed(8);
    } else {
        returnValue = Number(priceData).toFixed(4);
    }
    return returnValue;
};
// 价格格式化
var formatPrice = function() {
    var price = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    if (!price) return "-";
    if (price < 1) {
        return getZeroNums(price);
    }
    if (price >= 1 && price <= 100) {
        return Number(price).toFixed(4);
    }
    if (price >= 10000000000) {
        var ref;
        return "".concat((ref = Number(price / 1000000000)) === null || ref === void 0 ? void 0 : ref.toFixed(4), "B");
    }
    if (price >= 10000000) {
        var ref1;
        return "".concat((ref1 = Number(price / 1000000)) === null || ref1 === void 0 ? void 0 : ref1.toFixed(4), "M");
    }
    if (price >= 100000) {
        var ref2;
        return "".concat((ref2 = Number(price / 1000)) === null || ref2 === void 0 ? void 0 : ref2.toFixed(4), "K");
    }
    if (price > 100) {
        return Number(price).toFixed(2);
    }
    return Number(price);
};
// 格式化千分位
var formatNumber = function(num, price) {
    if (num === "-") {
        return "-";
    }
    if (price < 1) {
        return num;
    }
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(num)) {
        return 0;
    }
    var length = "".concat(num).split(".").length;
    var long = 0;
    if (length > 1) {
        long = "".concat(num).split(".")[1].length;
    }
    return Number(num).toLocaleString("en", {
        minimumFractionDigits: long
    });
};
// 格式化千分位
function formatNumber2(number) {
    var parts = number.toString().split(".");
    var integerPart = parts[0];
    integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    // 小数部分，组合为带有千分位的字符串
    // if (parts.length === 2) {
    //   const decimalPart = parts[1];
    //   return integerPart + "." + decimalPart;
    // }
    return integerPart;
}
var getRes = function(num) {
    var digit = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 3;
    // if (Number(num) === Math.floor(num)) return Math.floor(num);
    var res = [];
    var addNum = 0;
    // eslint-disable-next-line no-param-reassign
    num += "";
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(num.split("."), 2), zs = ref[0], xs = ref[1];
    var ref1 = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(/^(-?)(\d+\.\d+|\d+)$/.exec(zs), 3), symbol = ref1[1], zsNum = ref1[2];
    for(var i = 0; i < xs.length; i++){
        var ele = xs[i];
        // eslint-disable-next-line
        if (ele != 0) {
            if (xs[i + digit] && xs[i + digit] > 4) {
                addNum = 1;
                for(var j = i + (digit - 1); j >= 0; j--){
                    if (Number(xs[j]) + addNum === 10) res[j] = "0";
                    else {
                        res[j] = Number(xs[j]) + addNum;
                        addNum = 0;
                    }
                }
            } else {
                for(var k = i; k <= i + (digit - 1); k++){
                    res[k] = xs[k];
                }
            }
            break;
        } else res[i] = xs[i];
    }
    return getFullNum(Number("".concat(symbol + (Number(zsNum) + addNum), ".").concat(res.join(""))));
};
var getFullNum = function(num) {
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(num)) {
        return num;
    }
    // 处理不需要转换的数字
    var str = String(num);
    if (!/e/i.test(str)) {
        return num;
    }
    return Number(num).toFixed(18).replace(/\.?0+$/, "");
};
// 格式化代币金额
var formatTokenAmount = function(num) {
    // eslint-disable-next-line no-restricted-globals
    if (isNaN(num)) {
        return 0;
    }
    if (num >= 10000000000) {
        var ref;
        return "".concat((ref = Number(num / 1000000000)) === null || ref === void 0 ? void 0 : ref.toFixed(2), "B");
    }
    if (num >= 10000000) {
        var ref1;
        return "".concat((ref1 = Number(num / 1000000)) === null || ref1 === void 0 ? void 0 : ref1.toFixed(2), "M");
    }
    if (num >= 100000) {
        var ref2;
        return "".concat((ref2 = Number(num / 1000)) === null || ref2 === void 0 ? void 0 : ref2.toFixed(2), "K");
    }
    if (num > 100) {
        return Number(num).toFixed(2);
    }
    if (num >= 1) {
        return Number(num).toFixed(2);
    }
    if (num >= 0.1) {
        return Number(num).toFixed(3);
    }
    return getRes(num, 3);
};


/***/ }),

/***/ 60764:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "X": function() { return /* binding */ CurrencyLogo; },
  "g": function() { return /* binding */ DoubleCurrencyLogo; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/hooks/useActiveWeb3React.ts
var useActiveWeb3React = __webpack_require__(64011);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 3 modules
var styled_components_browser_esm = __webpack_require__(94589);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
;// CONCATENATED MODULE: ./src/views/Info/components/CurrencyLogo/LogoLoader.tsx





var BAD_SRCS = [];
/**
 * Renders an image by sequentially trying a list of URIs, and then eventually a fallback to HelpIcon
 */ var LogoLoader = function(_param) {
    var src = _param.src, alt = _param.alt, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "alt"
    ]);
    var ref = (0,react.useState)(0), refresh = ref[1];
    var srcFailedLoading = BAD_SRCS.includes(src);
    if (src && !srcFailedLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
            alt: alt,
            src: src,
            onError: function() {
                if (src) BAD_SRCS.push(src);
                refresh(function(i) {
                    return i + 1;
                });
            }
        }));
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, rest), {
        src: "/images/small-img/default-icon.png",
        alt: ""
    }));
// return <HelpIcon {...rest} />
};
/* harmony default export */ var CurrencyLogo_LogoLoader = (LogoLoader);

;// CONCATENATED MODULE: ./src/views/Info/components/CurrencyLogo/index.tsx
/* eslint-disable */ 


function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: ",
        ";\n  height: ",
        ";\n  border-radius: ",
        ";\n  /* box-shadow: 0px 6px 10px rgba(0, 0, 0, 0.075); */\n  background-color: ",
        ";\n  color: ",
        ";\n  margin-right: ",
        ";\n  z-index: ",
        ";\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 32px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}





var StyledLogo = (0,styled_components_browser_esm/* default */.ZP)(CurrencyLogo_LogoLoader).withConfig({
    componentId: "sc-641751a1-0"
})(_templateObject(), function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var size = param.size;
    return size;
}, function(param) {
    var theme = param.theme;
    return theme.colors.background;
}, function(param) {
    var theme = param.theme;
    return theme.colors.text;
}, function(param) {
    var firstimg = param.firstimg;
    return firstimg && "-6px";
}, function(param) {
    var firstimg = param.firstimg;
    return firstimg ? "4" : "3";
});
var CurrencyLogo = function(_param) {
    var address = _param.address, symbol = _param.symbol, _size = _param.size, size = _size === void 0 ? "24px" : _size, _firstimg = _param.firstimg, firstimg = _firstimg === void 0 ? "false" : _firstimg, rest = (0,_object_without_properties/* default */.Z)(_param, [
        "address",
        "symbol",
        "size",
        "firstimg"
    ]);
    var chainId = (0,useActiveWeb3React/* default */.Z)().chainId;
    var src = (0,react.useMemo)(function() {
        // const checksummedAddress = isAddress(address)
        if (address && symbol) {
            // return `https://assets-cdn.trustwallet.com/blockchains/smartchain/assets/${checksummedAddress}/logo.png`
            // return `https://s3.ap-southeast-1.amazonaws.com/noahark.pro/image/${chainId}-${address.toLowerCase()}-${symbol.toLowerCase()}.png`
            return "https://images.noahark.io/image/".concat(chainId, "-").concat(address.toLowerCase(), "-").concat(symbol.toLowerCase(), ".png");
        }
        return null;
    }, [
        address,
        symbol,
        chainId
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StyledLogo, (0,_object_spread/* default */.Z)({
        size: size,
        src: src,
        alt: "token logo",
        firstimg: firstimg
    }, rest));
};
var DoubleCurrencyWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-641751a1-1"
})(_templateObject1());
var DoubleCurrencyLogo = function(param) {
    var token0 = param.token0, token1 = param.token1, _size = param.size, size = _size === void 0 ? 16 : _size;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(DoubleCurrencyWrapper, {
        children: [
            (token0 === null || token0 === void 0 ? void 0 : token0.address) && (token0 === null || token0 === void 0 ? void 0 : token0.symbol) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo, {
                address: token0 === null || token0 === void 0 ? void 0 : token0.address,
                symbol: token0 === null || token0 === void 0 ? void 0 : token0.symbol,
                size: "".concat(size.toString(), "px"),
                firstimg: "true"
            }),
            (token1 === null || token1 === void 0 ? void 0 : token1.address) && (token1 === null || token1 === void 0 ? void 0 : token1.symbol) && /*#__PURE__*/ (0,jsx_runtime.jsx)(CurrencyLogo, {
                address: token1 === null || token1 === void 0 ? void 0 : token1.address,
                symbol: token1 === null || token1 === void 0 ? void 0 : token1.symbol,
                size: "".concat(size.toString(), "px")
            })
        ]
    });
};


/***/ }),

/***/ 58910:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Eh": function() { return /* binding */ Arrow; },
/* harmony export */   "Ob": function() { return /* binding */ PageButtons; },
/* harmony export */   "SS": function() { return /* binding */ Break; },
/* harmony export */   "_J": function() { return /* binding */ ClickableColumnHeader; },
/* harmony export */   "y6": function() { return /* binding */ TableWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(94589);
/* harmony import */ var _noahswap_uikit__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97114);
/* harmony import */ var _noahswap_uikit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4318);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  padding-top: 16px;\n  flex-direction: column;\n  gap: 16px;\n  background-color: ",
        ";\n  border-radius: ",
        ";\n  // border: 1px solid ",
        ";\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 0.2em;\n  margin-bottom: 1.2em;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  color: ",
        ";\n  padding: 0 20px;\n  :hover {\n    cursor: pointer;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  height: 1px;\n  // background-color: ",
        ";\n  background-color: #f6f6f6;\n  width: 100%;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}


var ClickableColumnHeader = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_noahswap_uikit__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-8639d6fd-0"
})(_templateObject());
var TableWrapper = (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(_noahswap_uikit__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-8639d6fd-1"
})(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.card.background;
}, function(param) {
    var theme = param.theme;
    return theme.radii.card;
}, function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});
var PageButtons = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8639d6fd-2"
})(_templateObject2());
var Arrow = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8639d6fd-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.primary;
});
var Break = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-8639d6fd-4"
})(_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.cardBorder;
});


/***/ }),

/***/ 40393:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ getPercentChange; }
/* harmony export */ });
/* unused harmony export getAmountChange */
/**
 * Get increase/decrease of value compared to the previous value (e.g. 24h volume compared to 24h volume the day before )
 * @param valueNow - more recent value
 * @param valueBefore - value to compare with
 */ var getAmountChange = function(valueNow, valueBefore) {
    if (valueNow && valueBefore) {
        return valueNow - valueBefore;
    }
    if (valueNow) {
        return valueNow;
    }
    return 0;
};
/**
 * Get increase/decrease of value compared to the previous value as a percentage
 * @param valueNow - more recent value
 * @param valueBefore - value to compare with
 */ var getPercentChange = function(valueNow, valueBefore) {
    if (valueNow && valueBefore) {
        return (valueNow - valueBefore) / valueBefore * 100;
    }
    return 0;
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2077,9774,2888,179], function() { return __webpack_exec__(96819); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);